import { useMutation } from "@shared/lib/hooks";
import { ToastService } from "@shared/lib/services";
import {
  PAYOUT_EXPORTS_QUERY_KEY,
  PAYOUTS_FACETS_QUERY_KEY,
  PAYOUTS_QUERY_KEY,
} from "../contsants";
import { CampaignService } from "../services/Campaign.service";

export function useCancelPayoutExport() {
  const {
    mutate: cancelPayoutExport,
    isLoading: isCancelling,
    isSuccess: isCancelled,
  } = useMutation({
    mutationFn: async (vendorPaymentBankExportId: string) => {
      return await CampaignService.cancelVendorPaymentsBankVerificationExport(
        vendorPaymentBankExportId
      ).catch(async (err) => {
        const responseBody = await err.response.json();
        ToastService.error(responseBody.msg);
        throw err;
      });
    },
    onSuccess: (client) => {
      ToastService.success("Payment file cancelled");
      setTimeout(() => {
        client.invalidateQueries({ queryKey: [...PAYOUT_EXPORTS_QUERY_KEY()] });
        client.invalidateQueries({ queryKey: [...PAYOUTS_QUERY_KEY()] });
        client.invalidateQueries({ queryKey: [...PAYOUTS_FACETS_QUERY_KEY()] });
      }, 1000);
    },
    options: { skipInvalidation: true },
  });

  return {
    cancelPayoutExport,
    isCancelling,
    isCancelled,
  };
}
